/**
 * Global application constants
 */
export const APPLICATION_NAME = "Single Skill Database";

export const API_STALE_TIME = {
	THIRTY_SECONDS: 30000,
	ZERO_SECONDS: 0,
};

export const API_CACHE_TIME = {
	ZERO_SECONDS: 0,
};

export const MAX_FILE_SIZE_MB = 1 * 1024 * 1024;

export const ALLOWED_FILES = ".pdf, .csv, .doc, .docx, .jpg, .jpeg, .png, .webp, .jfif";

export const MAX_FILE_SIZE_TITLE = "1MB";

// Job Application Constants
export const JOB_APPLICATION = {
	MAX_FILE_SIZE_MB: 2 * 1024 * 1024, // 2MB
	MAX_FILE_SIZE_TITLE: "2MB",
	ALLOWED_FILE_TYPES: [".pdf", ".doc", ".docx"],
	MAX_FILES_PER_FIELD: 5, // Max 5 files for certificate and experienceLetter
};

export const MAX_PAGES_TO_SHOW_FOR_PAGINATION = 5

export const LANGUAGES_KEYS = {
	en: "en",
	ur: "ur",
};

export const LANGUAGES_VALUES = {
	en: "🇺🇸 English",
	ur: "🇵🇰 اردو",
};

export const LANGUAGES = {
	"english": "English",
	"urdu": "Urdu",
};

export const EXPORT_OPTIONS = [
	{ value: "csv", label: "CSV" },
	{ value: "pdf", label: "PDF" },
	{ value: "excel", label: "Excel" },
];
